import script from "./AgentFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentFab.vue?vue&type=script&setup=true&lang=ts"

import "./AgentFab.vue?vue&type=style&index=0&id=5ad63d81&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad63d81"]])

export default __exports__